export default "__VITE_ASSET__DYE4xSSl__"